import { useState } from 'react'

import {
  EuiPageHeader,
  EuiHeaderSectionItemButton,
  EuiPopover,
  EuiAvatar,
  EuiText,
  EuiSpacer,
  EuiLink,
  EuiFlexItem,
  EuiFlexGroup,
} from '@elastic/eui'

import ThemeSetter from './themeSetter'

function Header() {
  const user = JSON.parse(localStorage.getItem('user'))
  const HeaderUserMenu = () => {
    const headerUserPopoverId = 'headerUserPopover_1'
    const [isOpen, setIsOpen] = useState(false)

    const onMenuButtonClick = () => {
      setIsOpen(!isOpen)
    }

    const closeMenu = () => {
      setIsOpen(false)
    }

    const button = (
      <EuiHeaderSectionItemButton
        aria-controls={headerUserPopoverId}
        aria-expanded={isOpen}
        aria-haspopup="true"
        aria-label="Account menu"
        onClick={onMenuButtonClick}
      >
        <EuiFlexGroup id="infoUserHeader">
          <EuiFlexItem>
            <EuiAvatar name={user.lastname + ' ' + user.firstname} size="m" />
          </EuiFlexItem>

          <EuiFlexItem>
            <span>
              {user.lastname
                ? user.lastname.substring(0, 1)
                : '' + '.' + user.firstname
                ? user.firstname
                : ''}
              <span className="ui-icon ui-icon-caret-1-s" />
            </span>
          </EuiFlexItem>
        </EuiFlexGroup>
      </EuiHeaderSectionItemButton>
    )

    return (
      <EuiPopover
        id={headerUserPopoverId}
        button={button}
        isOpen={isOpen}
        anchorPosition="downRight"
        closePopover={closeMenu}
        panelPaddingSize="none"
      >
        <div style={{ width: 320 }}>
          <EuiFlexGroup
            gutterSize="m"
            className="euiHeaderProfile"
            responsive={false}
          >
            <EuiFlexItem grow={false}>
              <EuiAvatar
                name={user.lastname + ' ' + user.firstname}
                size="xl"
              />
            </EuiFlexItem>

            <EuiFlexItem>
              <EuiText>
                <p>{user.lastname + ' ' + user.firstname}</p>
              </EuiText>

              <EuiSpacer size="m" />

              <EuiFlexGroup>
                <EuiFlexItem>
                  <EuiFlexGroup justifyContent="spaceBetween">
                    <EuiFlexItem grow={false}>
                      <EuiLink href="/Logout">Déconnexion</EuiLink>
                    </EuiFlexItem>
                  </EuiFlexGroup>
                </EuiFlexItem>
              </EuiFlexGroup>
            </EuiFlexItem>
          </EuiFlexGroup>
        </div>
      </EuiPopover>
    )
  }

  return <HeaderUserMenu />
}

function SwitchThemes() {
  return (
    <>
      <EuiFlexItem id="lightThemeSpan" component="span">
        Light
      </EuiFlexItem>

      <EuiFlexItem>
        <ThemeSetter />
      </EuiFlexItem>
    </>
  )
}

function PageHeader() {
  return (
    <EuiPageHeader
      id="headerTop"
      rightSideItems={[<Header />, <SwitchThemes />]}
    ></EuiPageHeader>
  )
}

export default PageHeader
